import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserModel } from '@app/modules/user/model/user';
import { UserState } from '@app/modules/user/store/user.state';
import { Navigate } from '@ngxs/router-plugin';
import { UserActions } from '@app/modules/user/store/user.actions';

@Injectable()
export class AuthHeadersInterceptor implements HttpInterceptor {

  /**
   * @param store
   */
  constructor(
    private readonly store: Store,
  ) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request: HttpRequest<any> = req;

    // UserState.model defaults to NULL until login hydrates it — an unguarded
    // read here crashed the interceptor, which silently killed EVERY request
    // fired during that window (pages hang on skeletons with no failed
    // request in the network tab).
    request = req.clone({
      setHeaders: {
        Authorization: `Bearer ${this.user?.token ?? ''}`
      },
    });

    return next.handle(request).pipe(
      catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            // A 401 from an auth endpoint (login / token refresh) is an expected
            // outcome the page handles itself (wrong password, MFA required, …) —
            // don't force a logout+reload, or the login flow (e.g. the MFA code
            // step) is destroyed before it can render.
            const isAuthEndpoint =
              req.url.indexOf('accounts/login') !== -1 ||
              req.url.indexOf('accounts/reissue') !== -1 ||
              req.url.indexOf('accounts/refresh') !== -1;

            if (req.url.indexOf('accounts/self') === -1 && !isAuthEndpoint && error.status === 401) {
              this.store.dispatch(new UserActions.RemoveUserFromStorage());
              this.store.dispatch(new Navigate(['/auth/login']));
              window.location.reload(); // @todo use meta reducer
            }
            else
            {
              let errorMessage = 'An unexpected error occurred.';

              if (error.status === 403) {
                if ((error.error != null) && (error.error.message === 'Forbidden')) {
                  errorMessage = 'Access denied. Please check your credentials or permissions.';
                }
                else if (error.error != null) {
                  errorMessage = error.error.message;
                }
              } else if (error.status === 404) {
                errorMessage = 'The requested resource was not found.';
              }
              else if ((error.error != null) && (error.error.message != null))
              {
                errorMessage = error.error.message;
              }
              //console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!',errorMessage);
              error.error.message = errorMessage;
              return throwError(error);
          }
        }
        return throwError(error);
      }),
    );
  }

  public get user(): UserModel {
    return this.store.selectSnapshot(UserState.model);
  }
}
